/*
 * YOUR CUSTOM JAVASCRIPT
 *
 * This module is imported after every framework, vendor, and feature module.
 */
document.addEventListener("DOMContentLoaded", () => {
    /*
     * ----------------------------------------------------------
     * Legal document configuration
     * ----------------------------------------------------------
     */

    const configs = [
        {
            document: "#privacy-document",
            navigation: "#privacy-navigation",
            section: ".privacy-section-card[id]",
            select: "#privacy-section-select",
            print: "[data-privacy-print]"
        },
        {
            document: "#terms-document",
            navigation: "#terms-navigation",
            section: ".terms-section-card[id]",
            select: "#terms-section-select",
            print: "[data-terms-print]"
        }
    ];

    const config = configs.find((item) =>
        document.querySelector(item.document)
    );

    if (!config) {
        return;
    }


    /*
     * ----------------------------------------------------------
     * Elements
     * ----------------------------------------------------------
     */

    const documentElement =
        document.querySelector(config.document);

    const navigation =
        document.querySelector(config.navigation);

    const navLinks =
        navigation?.querySelectorAll(".nav-link") ?? [];

    const sections =
        documentElement?.querySelectorAll(config.section) ?? [];

    const sectionSelect =
        document.querySelector(config.select);

    const printButton =
        document.querySelector(config.print);


    /*
     * ----------------------------------------------------------
     * Active navigation
     * ----------------------------------------------------------
     */

    const setActiveLink = (sectionId) => {
        navLinks.forEach((link) => {
            const isActive =
                link.getAttribute("href") === `#${sectionId}`;

            link.classList.toggle("active", isActive);

            if (isActive) {
                link.setAttribute("aria-current", "true");
            } else {
                link.removeAttribute("aria-current");
            }
        });
    };


    /*
     * ----------------------------------------------------------
     * Section observer
     * ----------------------------------------------------------
     */

    if (sections.length && navLinks.length) {
        const observer = new IntersectionObserver(
            (entries) => {
                const visibleSections = entries
                    .filter((entry) => entry.isIntersecting)
                    .sort(
                        (a, b) =>
                            a.boundingClientRect.top -
                            b.boundingClientRect.top
                    );

                if (!visibleSections.length) {
                    return;
                }

                setActiveLink(
                    visibleSections[0].target.id
                );
            },
            {
                root: null,
                rootMargin: "-20% 0px -65% 0px",
                threshold: 0
            }
        );

        sections.forEach((section) => {
            observer.observe(section);
        });
    }


    /*
     * ----------------------------------------------------------
     * Desktop navigation
     * ----------------------------------------------------------
     */

    navLinks.forEach((link) => {
        link.addEventListener("click", (event) => {
            const selector =
                link.getAttribute("href");

            if (!selector?.startsWith("#")) {
                return;
            }

            const section =
                document.querySelector(selector);

            if (!section) {
                return;
            }

            event.preventDefault();

            section.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

            history.replaceState(
                null,
                "",
                selector
            );

            setActiveLink(section.id);
        });
    });


    /*
     * ----------------------------------------------------------
     * Mobile navigation
     * ----------------------------------------------------------
     */

    sectionSelect?.addEventListener(
        "change",
        (event) => {
            const selector =
                event.target.value;

            if (!selector) {
                return;
            }

            const section =
                document.querySelector(selector);

            if (!section) {
                return;
            }

            section.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });

            history.replaceState(
                null,
                "",
                selector
            );

            setActiveLink(section.id);

            event.target.value = "";
        }
    );


    /*
     * ----------------------------------------------------------
     * Print
     * ----------------------------------------------------------
     */

    printButton?.addEventListener("click", () => {
        window.print();
    });


    /*
     * ----------------------------------------------------------
     * Initial active section
     * ----------------------------------------------------------
     */

    if (window.location.hash) {
        const initialSection =
            document.querySelector(
                window.location.hash
            );

        if (
            initialSection &&
            documentElement.contains(initialSection)
        ) {
            setActiveLink(initialSection.id);
        }
    } else if (sections.length) {
        setActiveLink(sections[0].id);
    }

});

